import angular, { auto } from "angular";

import { vsName as serviceName, DefaultValuesService } from '.'

export const vsName = `${serviceName}`
export const vsProviderName = `${vsName}Provider`
export const vsNgType = 'provider'

export class DefaultValuesProvider implements angular.IServiceProvider {

  private readonly defaultValueFactories: { [defaultValueName: string]: any[] | Function } = {}

  addDefaultValue(name: string, valueFactory: any[] | Function) {
    this.defaultValueFactories[name] = valueFactory
  }

  readonly $get = ['$q', '$injector', ($q: angular.IQService, $injector: auto.IInjectorService) => {
    const wrappedValueFactories = Object.entries(this.defaultValueFactories).reduce((result: { [name: string]: () => angular.IPromise<any> }, next) => {
      const [name, factory] = next
      result[name] = () => {
        //ugly type cast below to make typescript compiler allow the call.  It could be a Function as well
        const realized = $injector.invoke(factory as any[])
        return $q.when(realized)
      }

      return result
    }, {})

    return new DefaultValuesService(wrappedValueFactories)
  }]
}